/**
 * Deliverable review links (Advertising Plan first) are funneled through
 * splash (main.js's loadSplash) — the one unauth landing mvvLegit allows in
 * every auth state — same technique as invite links (inviteLink.js) and
 * questionnaire links (questionnaireLink.js). Whether the current page IS a
 * deliverable landing is decided by ?dl=&token= in the query string, not the
 * URL hash — the hash stays #/splash the whole time. Uses `dl` rather than
 * `uid`/`qr` specifically so the three link kinds are never ambiguous if
 * somehow more than one param set were present.
 *
 * @param {string} [search] - defaults to window.location.search
 * @returns {boolean}
 */
export function isDeliverableLink(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  return !!(params.get('dl') && params.get('token'));
}

/**
 * @param {string} [search] - defaults to window.location.search
 * @returns {{guid: string, token: string}|null}
 */
export function getDeliverableLinkParams(search = window.location.search) {
  const params = new URLSearchParams(search || '');
  const guid = params.get('dl');
  const token = params.get('token');
  return guid && token ? { guid, token } : null;
}
